import { normalizeEmail } from 'clerk_common/features/emailScanning';

export const isOwnerIdenticalToUser = (owner?: string, userEmail?: string) => {
  if (!owner || !userEmail) return false;

  return normalizeEmail(owner) === normalizeEmail(userEmail);
};

export function getItemSharedMailbox(
  item: Office.MessageRead
): Promise<string | undefined> {
  if (!item.getSharedPropertiesAsync) return Promise.resolve(undefined);
  const { emailAddress } = Office.context.mailbox.userProfile;
  return new Promise((resolve) => {
    item.getSharedPropertiesAsync((result) => {
      const owner = result.value?.owner;
      resolve(
        owner && !isOwnerIdenticalToUser(owner, emailAddress)
          ? owner
          : undefined
      );
    });
  });
}
